module.exports = __webpack_public_path__ + "img/cdd080e.jpg";